export default class ClickSearchCategoryEvent {
    export() {
        return {
            category: this.category,
        };
    }
}
